import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private user: UserService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate() {
    // op server kan ik niet auth token gebruiken en wil flikkering voorkomen.
    if (isPlatformBrowser(this.platformId)) {
      if (!this.user.isLoggedIn()) {
        this.router.navigate(['/auth/inloggen']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
